import {
    Dialog,
    Layout,
    Text
} from '@loadsmart/miranda-react';

// import talkToSalesIllustration from 'assets/images/talk-to-sales-illustration.svg';

export type TalkToSalesPendingDialogProps = {
    isOpen: boolean
    onClose: () => void
}

export function TalkToSalesPendingDialog({ isOpen, onClose }: TalkToSalesPendingDialogProps) {
    return (
        <Dialog
            open={isOpen}
            size="medium"
            data-testid="talk-to-sales-pending-dialog"
            onClose={(e) => {
                e.preventDefault?.();
                e.stopPropagation?.();
            }}

        >
            <DialogContent onClose={onClose} />
        </Dialog>
    )
}

type DialogContentProps = {
    onClose: () => void
}

function DialogContent({ onClose }: DialogContentProps) {
    return (
        <>
            <Dialog.Header>We`re finishing your setup</Dialog.Header>
            <Dialog.Body>
                <Layout.Group align="center">
                    <Layout.Stack >
                        <Text variant="body-md-bold" color="color-text-secondary">
                            We already have a job under analysis, please wait or reach out to your Account Manager.
                        </Text>
                        <Text variant="body-sm" color="color-text-tertiary">
                            Our Sales team has already received your previous request and is reviewing it.
                            We'll follow up shortly to help you move forward. In the meantime, please hold off on creating additional schedules for this role.
                        </Text>
                    </Layout.Stack>

                </Layout.Group>
            </Dialog.Body>
            <Dialog.Actions>
                <Dialog.ActionPrimary onClick={onClose}
                >
                    OK
                </Dialog.ActionPrimary>
            </Dialog.Actions>
        </>
    )
}
